/** @module lib/core/bibli */
import type { GraphJson } from 'src/lib/entities/Graph'
import type { LegacyGraph, LegacyPositionNode } from 'src/lib/legacy'
import type { RessourceJ3pBibli } from 'src/lib/types'

// attention, ces infos sont dupliquées dans scripts/helpers/sesatheque

const biblis: Record<string, string> = {
  bibliloca: 'https://bibliotheque.sesamath.local/',
  communloca: 'https://commun.sesamath.local/',
  sesabibli: 'https://bibliotheque.sesamath.net/',
  sesabidev: 'https://bibliotheque.sesamath.dev/',
  sesacomdev: 'https://commun.sesamath.dev/',
  sesacommun: 'https://commun.sesamath.net/'
}

interface LoadBibliResult {
  editgraphes?: {
    positionNodes: LegacyPositionNode[]
    titreNodes: string[]
  }
  graphe: GraphJson | LegacyGraph
  ressource: RessourceJ3pBibli
}

/**
 * Retourne la ressource récupérée sur sa bibli
 * @param rid
 */
export async function loadBibli (rid: string): Promise<LoadBibliResult> {
  const url = getUrl(rid)
  const response = await fetch(url)
  if (!response.ok) throw new Error(`HTTP error ${response.status} ${response.statusText} on ${url}`)
  const { data: ressource } = await response.json()
  if (ressource.type !== 'j3p') throw new Error(`La ressource ${rid} n’est pas une ressource j3p`)
  if (ressource.parametres.g) {
    return { editgraphes: ressource.parametres.editgraphes, graphe: ressource.parametres.g, ressource }
  }
  if (ressource.parametres.graph) {
    return { graphe: ressource.parametres.graph, ressource }
  }
  throw new Error('Ressource j3p invalide, sans parametres.g ni parametres.graph')
}

/**
 * Retourne l’url permettant de récupérer la ressource
 * @param rid
 * @throws Error si rid est invalide (ou fait référence à une bibli inconnue)
 */
function getUrl (rid: string): string {
  const chunks = rid.split('/')
  if (chunks.length !== 2) throw new Error(`rid ${rid} invalide`)
  const [baseId, id] = chunks
  if (typeof baseId !== 'string' || typeof id !== 'string') throw new Error(`rid ${rid} invalide`)
  if (!(baseId in biblis)) throw new Error(`baseId ${baseId} inconnue`)
  return biblis[baseId] + 'api/public/' + id
}
